import { render, staticRenderFns } from "./RatingComponent.vue?vue&type=template&id=e97b54a4&"
import script from "./RatingComponent.vue?vue&type=script&lang=js&"
export * from "./RatingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports